module.exports = __webpack_public_path__ + "img/quote.66b1275.png";